import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import LiveSection from "@/components/site/LiveSection";
import CultesSection from "@/components/site/CultesSection";
import AnnouncementsSection from "@/components/site/AnnouncementsSection";
import AboutSection from "@/components/site/AboutSection";
import EventsSection from "@/components/site/EventsSection";
import ContactSection from "@/components/site/ContactSection";
import RegistrationSection from "@/components/site/RegistrationSection";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function PublicHome() {
  const [info, setInfo] = useState(null);
  const [live, setLive] = useState(null);
  const [cultes, setCultes] = useState([]);
  const [events, setEvents] = useState([]);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      api.get("/church-info").then((r) => r.data).catch(() => null),
      api.get("/live").then((r) => r.data).catch(() => null),
      api.get("/cultes", { params: { limit: 9 } }).then((r) => r.data).catch(() => []),
      api.get("/events", { params: { upcoming: true, limit: 10 } }).then((r) => r.data).catch(() => []),
      api.get("/announcements", { params: { active_only: true } }).then((r) => r.data).catch(() => []),
    ]).then(([infoData, liveData, cultesData, eventsData, annData]) => {
      if (!mounted) return;
      setInfo(infoData);
      setLive(liveData);
      setCultes(cultesData);
      setEvents(eventsData);
      setAnnouncements(annData);
    });
    return () => { mounted = false; };
  }, []);

  return (
    <div data-testid="public-home" className="bg-[#FAFAFA]">
      <Navbar churchName={info?.name || "MEIGDA CAANAN"} logoUrl={info?.logo_url} />
      <Hero info={info} />
      <LiveSection live={live} />
      <AnnouncementsSection announcements={announcements} />
      <CultesSection cultes={cultes} />
      <AboutSection info={info} />
      <EventsSection events={events} />
      <RegistrationSection />
      <ContactSection />
      <Footer info={info} />
      <WhatsAppFloat number={info?.whatsapp} />
    </div>
  );
}
